module.exports = __webpack_public_path__ + "img/elburg-2.43a82e9c.jpg";